export function getErrorMessage(error: any) {
  if (error?.response?.status === 400) {
    return "Invalid request. Please check your input and try again.";
  }
  if (error?.response?.status === 404) {
    return error?.response?.data?.message ||  "Application not found.";
  }
  // Add more status codes as needed
  return "An unexpected error occurred. Please try again.";
}